import React, { useContext, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import classNames from 'classnames';
import { SessionContext } from '../context/SessionContext';
import styles from './Login.module.css';
import LoginForm from './LoginForm';
import LoginLennox from './LoginLennox';
import LoginContent from './LoginContent';
import { dataLayerPush } from '../components/Global/helpers';
import BrandInformation from './ICP/BrandInformation';
import CustomerBenefits from './ICP/CustomerBenefits';
import GetStartedToday from './ICP/GetStartedToday';
import SalesOptions from './ICP/SalesOptions';
import DealerInformation from './HomeDepot/DealerInformation';
import GetStarted from './HomeDepot/GetStarted';
import Benefits from './HomeDepot/Benefits';
import BrandInformationMCC from './MCC/BrandInformationMCC';
import CustomerBenefitsMCC from './MCC/CustomerBenefitsMCC';
import GetStartedTodayMCC from './MCC/GetStartedTodayMCC';
import CircularDiagramMCC from './MCC/CircularDiagramMCC';
import CustomerBenefitsWithBadges from './Trane/CustomerBenefitsWithBadges';
import GrowthBenefits from './Trane/GrowthBenefits';
import GetStartedTodayTrane from './Trane/GetStartedTodayTrane';
import TraneTextBubbleBanners from './Trane/TraneTextBubbleBanners';
import TraneCustomerValues from './Trane/TraneCustomerValues';
import DealerInformationNordyne from './Nordyne/DealerInformation';
import GetStartedNordyne from './Nordyne/GetStarted';
import GetStartedTodayMP from './MainlinePlus/GetStartedTodayMP';
import BrandInformationMP from './MainlinePlus/BrandInformationMP';
import CustomerBenefitsMP from './MainlinePlus/CustomerBenefitsMP';

const Login = () => {
    const clientSpecificLogin = ['icp', 'home depot', 'mcc', 'trane', 'nordyne', 'ge', 'mainline'];
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const accountNameToLower = accountName?.toLowerCase();

    if (accountNameToLower === 'lennox') {
        return <LoginLennox accountName={accountName} />;
    }

    dataLayerPush('Pageview', {
        pageTitle: 'Home',
        pagePath: '/home'
    });

    const getClassName = (accountname) => {
        switch (accountname) {
            case 'ge':
                return `${styles.vendorLoginGE}`;
            case 'rheem':
                return `${styles.vendorLoginRheem}`;
            case 'carrier':
                return `${styles.vendorLoginCarrier}`;
            case 'icp':
                return `${styles.vendorLoginICP}`;
            case 'home depot':
                return `${styles.vendorLoginHD}`;
            case 'mcc':
                return `${styles.vendorLoginMCC}`;
            case 'trane':
                return `${styles.vendorLoginTrane}`;
            case 'nordyne':
                return `${styles.vendorLoginNordyne}`;
            case 'mainline':
                return `${styles.vendorLoginMainline}`;
            default:
                return `${styles.vendorLoginRheem}`;
        }
    };

    return (
        <>
            <div
                className={classNames(
                    styles.vendorLogin,
                    accountNameToLower === 'home depot' && styles.vendorLoginHDOuter,
                    accountNameToLower === 'mainline' && styles.loginContainerMainline
                )}
            >
                <div className={getClassName(accountNameToLower)}>
                    {accountNameToLower !== 'ge'
                        && accountNameToLower !== 'icp'
                        && accountNameToLower !== 'home depot'
                        && accountNameToLower !== 'mcc'
                        && accountNameToLower !== 'trane'
                        && accountNameToLower !== 'nordyne'
                        && accountNameToLower !== 'mainline' && (
                            <Container>
                                <Col
                                    md='12'
                                    lg='12'
                                >
                                    <Col
                                        lg='4'
                                        md='5'
                                    >
                                        <LoginForm />
                                    </Col>
                                </Col>
                            </Container>
                        )}
                    {accountNameToLower === 'ge' && (
                        <>
                            <Container fluid>
                                <Container>
                                    <Row>
                                        <Col
                                            xl='5'
                                            lg='5'
                                            md='7'
                                            sm='7'
                                            xs='12'
                                            className='p-0 pb-3 pt-2'
                                        >
                                            <div className={styles.loginFormGE}>
                                                <LoginForm />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Container>
                        </>
                    )}
                    {accountNameToLower === 'trane' && (
                        <Container
                            fluid
                            className={styles.vendorLoginTrane}
                        >
                            <Col
                                xl={{ size: 4, offset: 8 }}
                                lg={{ size: 5, offset: 7 }}
                                md={{ size: 12 }}
                                className={styles.loginFormContainerTrane}
                            >
                                <div className={styles.loginFormTrane}>
                                    <LoginForm />
                                </div>
                            </Col>
                        </Container>
                    )}
                    {accountNameToLower === 'icp' && (
                        <Container fluid>
                            <Row>
                                <Col
                                    sm='12'
                                    md='7'
                                    lg='6'
                                    className={styles.loginRowContainer}
                                >
                                    <Row className={styles.loginRowSection}>
                                        <Col
                                            sm='12'
                                            md='8'
                                            lg='7'
                                            xl={{ size: 6, offset: 3 }}
                                            className={styles.loginFormContainer}
                                        >
                                            <LoginForm />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    )}
                    {accountNameToLower === 'home depot' && (
                        <Container className={styles.loginContainerHD}>
                            <Row>
                                <Col
                                    lg='8'
                                    xl='8'
                                ></Col>
                                <Col
                                    lg='4'
                                    xl='4'
                                    className='pt-2 mx-auto'
                                    md={{ size: 8, offset: 4 }}
                                >
                                    <Row>
                                        <Col className={styles.loginFormContainerHD}>
                                            <LoginForm />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    )}
                    {accountNameToLower === 'mcc' && (
                        <Container fluid>
                            <Row>
                                <Col
                                    sm='12'
                                    md='7'
                                    lg='6'
                                    className={styles.loginMccContainer}
                                >
                                    <Row className={styles.loginRowMccSection}>
                                        <Col
                                            sm='12'
                                            md='8'
                                            lg='7'
                                            xl={{ size: 6, offset: 1 }}
                                            className={styles.loginFormMccContainer}
                                        >
                                            <LoginForm />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    )}
                    {accountNameToLower === 'nordyne' && (
                        <Container
                            fluid
                            className={styles.loginContainerNordyne}
                        >
                            <Col
                                lg={{ size: 4, offset: 1 }}
                                md='12'
                                className={styles.loginformBGNordyne}
                            >
                                <LoginForm />
                            </Col>
                        </Container>
                    )}
                    {accountNameToLower === 'mainline' && (
                        <Container fluid>
                            <Row className={styles.loginRowMainline}>
                                <Col
                                    sm='12'
                                    md='7'
                                    lg='6'
                                >
                                    <Row>
                                        <Col
                                            sm='12'
                                            md='8'
                                            lg='7'
                                            xl={{ size: 5, offset: 3 }}
                                            className={styles.loginFormMainline}
                                        >
                                            <LoginForm />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    )}
                </div>
            </div>
            {!clientSpecificLogin.includes(accountNameToLower) && <LoginContent />}
            {accountNameToLower === 'icp' && (
                <>
                    <BrandInformation />
                    <CustomerBenefits />
                    <GetStartedToday />
                    <SalesOptions />
                </>
            )}
            {accountNameToLower === 'home depot' && (
                <>
                    <DealerInformation />
                    <GetStarted />
                    <Benefits />
                </>
            )}
            {accountNameToLower === 'mcc' && (
                <>
                    <BrandInformationMCC />
                    <CustomerBenefitsMCC />
                    <GetStartedTodayMCC />
                    <CircularDiagramMCC />
                </>
            )}
            {accountNameToLower === 'trane' && (
                <Container
                    fluid
                    className='p-0 m-0'
                >
                    <CustomerBenefitsWithBadges />
                    <GrowthBenefits />
                    <GetStartedTodayTrane />
                    <TraneTextBubbleBanners />
                    <TraneCustomerValues />
                </Container>
            )}
            {accountNameToLower === 'nordyne' && (
                <Container
                    fluid
                    className='p-0 m-0'
                >
                    <DealerInformationNordyne />
                    <GetStartedNordyne />
                </Container>
            )}
            {accountNameToLower === 'mainline' && (
                <>
                    <GetStartedTodayMP />
                    <BrandInformationMP />
                    <CustomerBenefitsMP />
                </>
            )}
        </>
    );
};

export { Login };
